<component-modal [showClose]="true" [showHeader]="true" [showFooter]="false">
  <ng-container body>
    <div class="choose-plan-modal">
      <!-- Header Section -->
      <div class="modal-header-section">
        <div class="header-content">
          <h3>{{ headerTitle() }}</h3>
          <p class="text-muted fs-6 mb-0">{{ headerSubtitle() }}</p>
        </div>

        <!-- Billing Cycle Toggle -->
        <div class="billing-toggle-container">
          <div class="billing-toggle">
            <div class="toggle-option" [class.active]="billingCycle() === 'monthly'" (click)="billingCycle.set('monthly')">
              Monthly
            </div>
            <div class="toggle-option" [class.active]="billingCycle() === 'yearly'" (click)="billingCycle.set('yearly')">
              <span>Yearly</span>
              <div class="discount-badge">-20% off</div>
            </div>
          </div>
        </div>
      </div>

      @if (isLoading()) {
        <div class="d-flex justify-content-center p-5">
          <div class="spinner-border" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      } @else {
        <!-- Plans Table -->
        <div class="plans-table">
          <!-- Header Row -->
          <div class="table-header">
            <div class="feature-column">
              <h3 class="table-title">Choose a Plan</h3>
            </div>
            @for (plan of plans(); track plan.id) {
              <div class="plan-column" [class.popular]="plan.type === 'FREE'">
                <div class="plan-header">
                  <div class="plan-name-section">
                    <div class="plan-name-row">
                      <h4 class="plan-name">{{ plan.name }}</h4>
                      @if (plan.name === "Plus") {
                        <div class="popular-badge">Popular</div>
                      }
                    </div>
                    <div class="plan-price">
                      @if (billingCycle() === "monthly") {
                        <span class="price">${{ plan.monthlyPrice || 0 }}</span>
                        <span class="period">/Month</span>
                      } @else {
                        <span class="price">${{ plan.annualPrice || 0 }}</span>
                        <span class="period">/Year</span>
                      }
                    </div>
                  </div>
                  <button
                    class="btn w-100"
                    [class.btn-primary]="plan.type === 'FREE'"
                    [class.btn-light]="plan.type !== 'FREE'"
                    [disabled]="
                      isRedirecting() || plan.id === currentUserPlanId() || (billingCycle() === 'yearly' && plan.type === 'FREE')
                    "
                    (click)="onUpgrade(plan)">
                    @if (isRedirecting()) {
                      <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    } @else if (billingCycle() === "yearly" && plan.type === "FREE") {
                      Not Available
                    } @else {
                      {{ plan.id === currentUserPlanId() ? "Current Plan" : "Get Started" }}
                    }
                  </button>
                </div>
              </div>
            }
          </div>

          <!-- Feature Rows -->
          <div class="table-row">
            <div class="feature-column">
              <span class="feature-label">Request Limit</span>
            </div>
            @for (plan of plans(); track plan.id) {
              <div class="plan-column" [class.popular]="plan.type === 'FREE'">
                <div class="feature-value">
                  {{ plan.tokensLimit ? (plan.tokensLimit | number) : "1 Million" }}
                </div>
              </div>
            }
          </div>

          <div class="table-row">
            <div class="feature-column">
              <span class="feature-label">Private docs amount</span>
            </div>
            @for (plan of plans(); track plan.id) {
              <div class="plan-column" [class.popular]="plan.type === 'FREE'">
                <div class="feature-value">
                  @if (plan.maxPrivateDocuments) {
                    {{ plan.maxPrivateDocuments }}
                  } @else {
                    <custom-icon name="check" [size]="16" viewBox="0 0 16 16" />
                    <span>Unlimited</span>
                  }
                </div>
              </div>
            }
          </div>

          <div class="table-row">
            <div class="feature-column">
              <span class="feature-label">Public docs amount</span>
            </div>
            @for (plan of plans(); track plan.id) {
              <div class="plan-column" [class.popular]="plan.type === 'FREE'">
                <div class="feature-value">
                  @if (plan.maxPublicDocuments) {
                    {{ plan.maxPublicDocuments }}
                  } @else {
                    <custom-icon name="check" [size]="16" viewBox="0 0 16 16" />
                    <span>Unlimited</span>
                  }
                </div>
              </div>
            }
          </div>

          <div class="table-row">
            <div class="feature-column">
              <span class="feature-label">Collab docs amount</span>
            </div>
            @for (plan of plans(); track plan.id) {
              <div class="plan-column" [class.popular]="plan.type === 'FREE'">
                <div class="feature-value">
                  @if (plan.maxSharedDocuments) {
                    {{ plan.maxSharedDocuments }}
                  } @else {
                    <custom-icon name="check" [size]="16" viewBox="0 0 16 16" />
                    <span>Unlimited</span>
                  }
                </div>
              </div>
            }
          </div>

          <div class="table-row">
            <div class="feature-column">
              <span class="feature-label">Expiration</span>
            </div>
            @for (plan of plans(); track plan.id) {
              <div class="plan-column" [class.popular]="plan.type === 'FREE'">
                <div class="feature-value">
                  @if (plan.expirationPeriod && plan.expirationUnit) {
                    {{ plan.expirationPeriod }} {{ plan.expirationUnit.toLowerCase() }}
                  } @else {
                    @if (billingCycle() === "monthly") {
                      1 month
                    } @else {
                      1 year
                    }
                  }
                </div>
              </div>
            }
          </div>

          <div class="table-row">
            <div class="feature-column">
              <span class="feature-label">API Keys</span>
            </div>
            @for (plan of plans(); track plan.id) {
              <div class="plan-column" [class.popular]="plan.type === 'FREE'">
                <div class="feature-value">
                  @if (plan.allowApiKeys) {
                    <custom-icon name="check" [size]="16" viewBox="0 0 16 16" />
                  } @else {
                    <span>—</span>
                  }
                </div>
              </div>
            }
          </div>

          <div class="table-row">
            <div class="feature-column">
              <span class="feature-label">Auto-renew</span>
            </div>
            @for (plan of plans(); track plan.id) {
              <div class="plan-column" [class.popular]="plan.type === 'FREE'">
                <div class="feature-value">
                  @if (plan.allowAutoRenew) {
                    <custom-icon name="check" [size]="16" viewBox="0 0 16 16" />
                  } @else {
                    <span>—</span>
                  }
                </div>
              </div>
            }
          </div>
        </div>

        @if (showSkipButton()) {
          <div class="skip-section">
            <button type="button" class="btn btn-light" (click)="activeModal.close()">Skip</button>
          </div>
        }
      }
    </div>
  </ng-container>
</component-modal>
